module.exports = __webpack_public_path__ + "img/21508f5.svg";